import { inject, Injectable } from '@angular/core';
import { LanguagesService } from './languages.service';
import { MappingService } from './mapping.service';

@Injectable({
    providedIn: 'root',
})
export class SharedInboxService {
    private languageService = inject(LanguagesService);
    private _mappingService = inject(MappingService);

    trackByFunction = (
        index: number,
        row: {
            caseInstance: { cid: number };
            taskInstance: { taskId: number };
            taskInstances: { taskId: number }[];
            signalInstance: { id: number };
        },
    ) => {
        const { caseInstance, taskInstance, taskInstances, signalInstance } = row || {};
        if (caseInstance && taskInstance) {
            return `${caseInstance.cid}-${taskInstance.taskId}`;
        }

        if (Array.isArray(taskInstances)) {
            return `${caseInstance.cid}`;
        }

        if (row?.signalInstance) {
            return `${caseInstance.cid}-${signalInstance.id}`;
        }

        return index;
    };

    // Used for pagination language change
    getPageSizeOpts(pageSizeOptions: Array<{ value: number; viewValue: string }>) {
        const rowTranslation = this.languageService.getTranslation('default-cm-rows') || 'Rows';
        const paginationOptions = pageSizeOptions.map((opts) => ({
            ...opts,
            viewValue: `${opts.value} ${rowTranslation}`,
        }));
        return paginationOptions;
    }

    async transformCaseData(data: any[], currentInboxConfig: any): Promise<Map<any, string>[]> {
        const transformedData = await Promise.all(
            data.map(async (row: any) => {
                const transformedRow = new Map<any, string>();
                for (const column of currentInboxConfig.columns) {
                    if (!column.hideable) {
                        try {
                            const mappedValue = await this._mappingService.updateValue(row, column);
                            transformedRow.set(column, mappedValue);
                        } catch (error) {
                            console.error(`Error mapping value for column "${column?.name}"`, error);
                        }
                    }
                }
                return transformedRow;
            }),
        );
        return transformedData;
    }
}
